import { Component, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field';
import { FieldConfig } from '../../models/field-config';
import { LocaleService } from '../../../core/services/locale.service';

@Component({
  selector: 'app-form-calendar',
  templateUrl: './form-calendar.component.html',
  styleUrls: ['./form-calendar.component.scss']
})
export class FormCalendarComponent implements Field {

  calenderlocale: any = this.locale.getCalendarDA();
  config: FieldConfig;
  group: FormGroup;

  constructor(private locale: LocaleService){}

}
